import { ChartStyles } from '../misc/constants';

// NOTE https://github.com/tradingview/charting_library/wiki/Overrides
export const overrides = {
  volumePaneSize: 'medium', // NOTE large, medium, small, tiny

  'paneProperties.background': ChartStyles.Color.Background,
  'paneProperties.backgroundType': 'solid',
  'paneProperties.topMargin': 20,
  'paneProperties.bottomMargin': 15,
  // 가로선 세로선
  'paneProperties.vertGridProperties.style': ChartStyles.Line.Solid,
  'paneProperties.vertGridProperties.color': ChartStyles.Color.Border.Light,
  'paneProperties.horzGridProperties.style': ChartStyles.Line.Solid,
  'paneProperties.horzGridProperties.color': ChartStyles.Color.Border.Light,
  // 마우스 따라다니는 십자선
  'paneProperties.crossHairProperties.width': 1,
  'paneProperties.crossHairProperties.style': ChartStyles.Line.Dashed,
  'paneProperties.crossHairProperties.color': ChartStyles.Color.Text3,
  // 차트 좌상단의 각종 값 글자들
  // 'paneProperties.legendProperties.showStudyTitles': true, // MA (15, close, 0) 전체
  // 'paneProperties.legendProperties.showStudyArguments': true, // MA (15, close, 0) 등 괄호안 내용들
  'paneProperties.legendProperties.showLegend': true,
  'paneProperties.legendProperties.showStudyValues': true, // CHANGED 뒤에 붙는 25660 등 지저분한 값들
  'paneProperties.legendProperties.showSeriesTitle': false, // 심볼명 숨김 (BTCUSDT.PERP 등)
  'paneProperties.legendProperties.showSeriesOHLC': true, // OHLC 정보는 유지

  // 'scalesProperties.showLeftScale': false, // 왼쪽 축, 안쓴다.
  // 'scalesProperties.showRightScale': true,
  'scalesProperties.fontSize': 10, // 축 폰트 크기
  'scalesProperties.backgroundColor': '#ff0f00', // ?
  'scalesProperties.lineColor': ChartStyles.Color.Line, // 축 선 색상
  'scalesProperties.textColor': ChartStyles.Color.Text3, // 축 숫자 색상
  'scalesProperties.scaleSeriesOnly': false, // ?
  // 'scalesProperties.showSeriesLastValue': true, // 우측 현재가 딱지
  // 'scalesProperties.showSeriesPrevCloseValue': false, // ?
  'scalesProperties.showStudyLastValue': false, // MA 등의 현재가 딱지
  'scalesProperties.showStudyPlotLabels': false, // MA 등의 레이블
  'scalesProperties.showSymbolLabels': false, // 보스/이더리움 딱지

  'timeScale.rightOffset': 15, // 우측 여백

  'mainSeriesProperties.style': 1, // 기본 차트는 캔들 차트.
  'mainSeriesProperties.showCountdown': false, // 우측에 갱신 카운트다운
  'mainSeriesProperties.visible': true,
  'mainSeriesProperties.showPriceLine': true, // 현재가 수평선
  'mainSeriesProperties.priceLineWidth': 1,
  // 'mainSeriesProperties.minTick': 'default', // NOTE 소숫점 제한 기능 0.01 : '100', 1.005 : '1000'
  // 'mainSeriesProperties.priceAxisProperties.autoScale': true, // 차트 드래그시 우측 바 자동조절
  // 'mainSeriesProperties.priceAxisProperties.autoScaleDisabled': false,
  // 'mainSeriesProperties.priceAxisProperties.percentage': false, // 값을 기본 퍼센트로 보여주는 기능
  // 'mainSeriesProperties.priceAxisProperties.percentageDisabled': true,
  // 'mainSeriesProperties.priceAxisProperties.log': false, // 값을 기본 로그로 보여주는 기능
  // 'mainSeriesProperties.priceAxisProperties.logDisabled': false,
  // 'mainSeriesProperties.priceAxisProperties.percentageDisabled': true,
  // Candles
  'mainSeriesProperties.candleStyle.upColor': ChartStyles.Color.CandleUp, // 촛대 몸통 색상
  'mainSeriesProperties.candleStyle.downColor': ChartStyles.Color.CandleDown,
  'mainSeriesProperties.candleStyle.drawWick': true, // 촛대 위아래 선
  'mainSeriesProperties.candleStyle.wickUpColor': ChartStyles.Color.CandleUp,
  'mainSeriesProperties.candleStyle.wickDownColor': ChartStyles.Color.CandleDown,
  'mainSeriesProperties.candleStyle.drawBorder': true,
  'mainSeriesProperties.candleStyle.borderUpColor': ChartStyles.Color.CandleUp,
  'mainSeriesProperties.candleStyle.borderDownColor': ChartStyles.Color.CandleDown,
  'mainSeriesProperties.candleStyle.barColorsOnPrevClose': false,
  // Hollow Candles
  'mainSeriesProperties.hollowCandleStyle.upColor': ChartStyles.Color.CandleUp,
  'mainSeriesProperties.hollowCandleStyle.downColor': ChartStyles.Color.CandleDown,
  'mainSeriesProperties.hollowCandleStyle.drawWick': true,
  'mainSeriesProperties.hollowCandleStyle.drawBorder': true,
  'mainSeriesProperties.hollowCandleStyle.borderUpColor': ChartStyles.Color.CandleUp,
  'mainSeriesProperties.hollowCandleStyle.borderDownColor': ChartStyles.Color.CandleDown,
  'mainSeriesProperties.hollowCandleStyle.wickUpColor': ChartStyles.Color.CandleUp,
  'mainSeriesProperties.hollowCandleStyle.wickDownColor': ChartStyles.Color.CandleDown,
  // Heikin Ashi
  'mainSeriesProperties.haStyle.upColor': ChartStyles.Color.CandleUp,
  'mainSeriesProperties.haStyle.downColor': ChartStyles.Color.CandleDown,
  'mainSeriesProperties.haStyle.drawBorder': true,
  'mainSeriesProperties.haStyle.borderUpColor': ChartStyles.Color.CandleUp,
  'mainSeriesProperties.haStyle.borderDownColor': ChartStyles.Color.CandleDown,
  'mainSeriesProperties.haStyle.drawWick': true,
  'mainSeriesProperties.haStyle.wickUpColor': ChartStyles.Color.CandleUp,
  'mainSeriesProperties.haStyle.wickDownColor': ChartStyles.Color.CandleDown,
  'mainSeriesProperties.haStyle.barColorsOnPrevClose': false,
  // Bar
  'mainSeriesProperties.barStyle.upColor': ChartStyles.Color.CandleUp,
  'mainSeriesProperties.barStyle.downColor': ChartStyles.Color.CandleDown,
  'mainSeriesProperties.barStyle.barColorsOnPrevClose': false,
  'mainSeriesProperties.barStyle.dontDrawOpen': false,
  // Line
  'mainSeriesProperties.lineStyle.color': ChartStyles.Color.Blue,
  'mainSeriesProperties.lineStyle.linestyle': ChartStyles.Line.Solid,
  'mainSeriesProperties.lineStyle.linewidth': 2,
  'mainSeriesProperties.lineStyle.priceSource': 'close',
  // Area
  'mainSeriesProperties.areaStyle.color1': ChartStyles.Color.Blue,
  'mainSeriesProperties.areaStyle.color2': 'rgba(10, 132, 255, 0)',
  'mainSeriesProperties.areaStyle.linecolor': ChartStyles.Color.Blue,
  'mainSeriesProperties.areaStyle.linestyle': ChartStyles.Line.Solid,
  'mainSeriesProperties.areaStyle.linewidth': 2,
  'mainSeriesProperties.areaStyle.priceSource': 'close',
  // Baseline
  'mainSeriesProperties.baselineStyle.baselineColor': ChartStyles.Color.Yellow,
  'mainSeriesProperties.baselineStyle.topFillColor1': ChartStyles.Color.CandleUp,
  'mainSeriesProperties.baselineStyle.topFillColor2': ChartStyles.Color.TriggerLong,
  'mainSeriesProperties.baselineStyle.bottomFillColor1': ChartStyles.Color.TriggerShort,
  'mainSeriesProperties.baselineStyle.bottomFillColor2': ChartStyles.Color.CandleDown,
  'mainSeriesProperties.baselineStyle.topLineColor': ChartStyles.Color.Up,
  'mainSeriesProperties.baselineStyle.bottomLineColor': ChartStyles.Color.CandleDown,
  'mainSeriesProperties.baselineStyle.topLineWidth': 2,
  'mainSeriesProperties.baselineStyle.bottomLineWidth': 2,
  'mainSeriesProperties.baselineStyle.priceSource': 'close',
  'mainSeriesProperties.baselineStyle.transparency': 80,
  'mainSeriesProperties.baselineStyle.baseLevelPercentage': 50,
};

export const studiesOverrides = {
  // 참조
  // https://www.tradingview.com/charting-library-docs/latest/customization/overrides/Studies-Overrides
  // 볼륨
  'Volume.volume.color.0': ChartStyles.Color.Down,
  'Volume.volume.color.1': ChartStyles.Color.Up,
  'Volume.volume.transparency': 70,
  'Volume.volume ma:plot.color': ChartStyles.Color.Pick.E40,
  'Volume.volume ma:plot.linewidth': 1,
  // 'volume.volume ma.visible': true, // 원래 동작해야하는데 지금 없는 옵션으로 인식
  // 이동평균선 // 추가할 수록 색이 변하기 때문에 냅둔다.
  // 'moving average.plot.linewidth': 2,
  // 'moving average.plot.color': COLOR.PICK.F,
  // 'moving average.plot.linestyle': LINESTYLE.DOTTED,
  // 볼린저밴드
  'Bollinger Bands.median.color': ChartStyles.Color.Pick.D,
  'Bollinger Bands.median.transparency': 1,
  'Bollinger Bands.median.linewidth': 1,
  'Bollinger Bands.upper.color': ChartStyles.Color.Pick.B,
  'Bollinger Bands.upper.linewidth': 1,
  'Bollinger Bands.lower.color': ChartStyles.Color.Pick.B,
  'Bollinger Bands.lower.linewidth': 1,
  'Bollinger Bands.plots background.color': ChartStyles.Color.Pick.B05,
  // 일목균형표
  'Ichimoku Cloud.conversion line.color': ChartStyles.Color.Pick.D,
  'Ichimoku Cloud.base line.color': ChartStyles.Color.Pick.G,
  // 'Ichimoku Cloud.lagging span.color': COLOR.PICK.A,
  // 'Ichimoku Cloud.lead 1.color': COLOR.PICK.E,
  // 'Ichimoku Cloud.lead 2.color': COLOR.PICK.C,
  // RSI
  'Relative Strength Index.plot.color': ChartStyles.Color.Pick.C,
  'Relative Strength Index.plot.linewidth': 1,
  'Relative Strength Index.upperlimit.color': ChartStyles.Color.Pick.B,
  'Relative Strength Index.upperlimit.linewidth': 1,
  'Relative Strength Index.upperlimit.linestyle': ChartStyles.Line.Dashed,
  'Relative Strength Index.lowerlimit.color': ChartStyles.Color.Pick.B,
  'Relative Strength Index.lowerlimit.linewidth': 1,
  'Relative Strength Index.lowerlimit.linestyle': ChartStyles.Line.Dashed,
  'Relative Strength Index.hlines background.color': ChartStyles.Color.Pick.B05,
  // https://github.com/tradingview/charting_library/issues/1212
  // NOTE: 언체크 하진 못하고 투명하게 해야함..
  // 상대강도지수 MACD
  'MACD.histogram.plottype': 'columns',
  'MACD.histogram.color': ChartStyles.Color.Pick.B40,
  'MACD.histogram.linewidth': 1,
  'MACD.macd.color': ChartStyles.Color.Up,
  'MACD.macd.linewidth': 1,
  'MACD.signal.color': ChartStyles.Color.Down,
  'MACD.signal.linewidth': 1,
};

// export const shapeOverrides = {
//   linestyle: 0,
//   linewidth: 1,
//   horzLabelsAlign: 'right',
//   showPrice: true,
//   showLabel: true,
//   fontsize: 10,
// };
